<template>
  <div class="landing-page-share">
    <div class="share-button">
      <rich-button
        size="max"
        icon="icon-filled_whatsapp"
        roundValue="16px"
        @click="handleDefaultShare"
        custom-class="custom-class"
      >{{ $t('FoodD_optimization_Wiuc_vkvD'/** 邀请你的朋友 */) }}</rich-button>
    </div>
    <div class="other-button">
      <rich-button
        size="max"
        roundValue="16px"
        outline
        custom-class="custom-class"
        @click="handleOtherShare"
      >{{ $t('FoodD_optimization_pADD_hRLc'/** 其他 */) }}</rich-button>
    </div>
  </div>
</template>

<script>
import { PLATFORM_BRIDGE_METHOD } from '@/components/share/platformConfig'
import { getShareConfig, getUrlLanguage } from "@/common/js/utils";
import { dgdButtonClick, dgdInviteOtherPopup } from '@/page/d/xtd/config/getTrack'
import Share from '@/components/share/index'
import CopyPanel from './copyPanel'

const OPERATION_NAME_MAP_TYPE = {
  'facebook': 1,
  'twitter': 2,
  'systemEntrance': 3,
  'close': 4,
  'copy': 5
}

export default {
  name: 'GuideShare',
  props: {
    share: {
      type: Object,
      default: () => {
        return {}
      }
    },
    trackAttrs: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    Share,
    CopyPanel
  },
  data () {
    return {
      shareConfig: {
        config: {},
        order: [],
      },
    }
  },
  computed: {
    selectShare() {
      const { share: {selectShare = 'whatsapp'} = {}} = this
      return selectShare
    }
  },
  async mounted() {
    await this.getShareConfigInfo()
  },
  methods: {
    // 默认分享方式
    handleDefaultShare () {
      const { selectShare, trackAttrs, shareConfig: {config = {}} = {} } = this
      dgdButtonClick({
        ...trackAttrs,
        click_type: 1 // 1 邀请
      })
      const defaultConfig = config[selectShare] || {}
      const bridge = PLATFORM_BRIDGE_METHOD[selectShare] || ''
      this.shareCommon(bridge, defaultConfig)
    },
    // 调用分享bridge
    async shareCommon (bridgeMethod, config) {
      const { url, title, content, icon } = config
      // 分享whatsapp、facebook调面板都不支持回调, 不做回调处理
      await this.SodaBridge(bridgeMethod, {
        url,
        title,
        content,
        icon
      })
    },
    // 获取在第三端分享时的配置
    async getShareConfigInfo () {
      const { share = {}, trackAttrs: { country = ''} = {}} = this
      const { showCode = '', shareOptions = {}, shareOrder = [], selectShare } = share
      const shareUrl = `${window.location.protocol}//www.didi-food.com/${getUrlLanguage()}/mobile-delivery/register?share=1&activationCode=${showCode}&country=${country}`
      this.shareConfig.config = await getShareConfig(
        shareOptions,
        shareUrl,
        [...shareOrder, selectShare]
      );
      this.shareConfig.order = shareOrder
    },
    handleOtherShare () {
      const { trackAttrs } = this
      dgdButtonClick({
        ...trackAttrs,
        click_type: 2 // 2 其他
      })
      this.$emit('handle-scroll', true)
      const { share: {showCode = '', shareOptions: {referralCode = ''} = {} } = {} } = this 
      const floating = this.$Floating({
        type: 'floating',
        title: '',
        leftBtn: 'richic-close',
        onCancel: () => {
          this.handleClickTrack('close')
          this.$emit('handle-scroll', false)
        },
        extClass: 'share-floating',
        destroy: true,
        isShowShadow: true,
        content: (
          <div>
            <Share config={this.shareConfig} on-handle-click-track={this.handleClickTrack} trackAttrs={this.trackAttrs} title={this.$t('FoodD_optimization_rIEQ_UWUa'/** 分享 */)} />
            <CopyPanel referralCode={referralCode} showCode={showCode} on-handle-click-track={this.handleClickTrack} />
          </div>
        )
      })
    },
    handleClickTrack (operationName) {
      const { trackAttrs } = this
      dgdInviteOtherPopup({
        ...trackAttrs,
        click_type: OPERATION_NAME_MAP_TYPE[operationName]
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
.landing-page-share {
  .share-button {
    margin-bottom: 28px;

    ::v-deep .rich-btn{
      background: #25ce41;
      height: 108px;
      font-size: 36px;
    }
  }
  .other-button {
    ::v-deep .rich-btn-outline:after {
      border-color: #25ce41;
    }
    ::v-deep .rich-btn-outline {
      background: rgba(255,255,255,0.70);
      backdrop-filter: blur(100px);
      border-radius: 32px !important;
      color: #25ce41;
      height: 108px;
      font-size: 36px;
    }
  }
}
.custom-class {
  font-family: 'DiDiSans-Pro-Medium';
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style lang="stylus">
.share-floating {
  .share-wrap.no-px2rem .share .icons {
    justify-content: space-between;
  }
  .share-wrap.no-px2rem .share .icons .icon img {
    width: 50px;
    height: 50px;
  }
}
.share-floating-title {

}
</style>
